import React from "react";
import * as Mui from "@mui/material";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import * as Icons from "react-feather";
import { connect } from "react-redux";
import { RootState } from "redux/store";
import { getOpenTasksForLead, getUser } from "redux/selector";
import { Lead } from "model/lead";
import { TasksComponent } from "component/shared/tasks-component";
import { styles } from "./style";
import { Task } from "model/task";
import { AppCard } from "component/shared/app-card";

const mapStateToProps = (state: RootState, ownProps: OwnProps) => {
	const leadId = ownProps.lead.id;
	return {
		tasks: getOpenTasksForLead(state, leadId),
		user: getUser(state)
	};
};

interface Props
	extends ReturnType<typeof mapStateToProps>,
		WithStyles<typeof styles> {
	lead: Lead;
}

interface OwnProps {
	lead: Lead;
}

interface State {
	taskDialogIsOpen: boolean;
}

class Component extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {
			taskDialogIsOpen: false
		};
	}

	public render() {
		const { tasks, lead, classes = {}, user } = this.props;
		const { taskDialogIsOpen } = this.state;
		let filteredTasks = user.admin ? tasks : tasks.filter(task => task.agentId === user.agent?.id);

		return (
			<AppCard>
				<Mui.CardHeader
					title="Tasks"
					classes={{
						title: classes.title,
						action: classes.newButtonAction
					}}
					action={
						<Mui.Button
							color="primary"
							onClick={() => this.setState({ taskDialogIsOpen: true })}
							startIcon={<Icons.Plus size={16} />}
						>
							Add Task
						</Mui.Button>
					}
				/>
				<TasksComponent
					lead={lead}
					tasks={filteredTasks}
					taskDialogIsOpen={taskDialogIsOpen}
					onCloseDialog={() => this.setState({ taskDialogIsOpen: false })}
				/>
			</AppCard>
		);
	}
}

export const TasksCard = withStyles(connect(mapStateToProps)(Component), styles);
